import React, { useState } from 'react'
import { FaSave } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import { MdClose } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { saveWorkFlow, editWorkFlow, getStages } from 'actions/WorkFlowActions';
import { notify } from 'utils';
import { setWorkFlowSelected } from 'redux/workFlow.slice';
import { ModalConfirm } from './Modals/ModalConfirm';

const CardWorkFlow = ({ workFlow, index, dispatch, projectId, workFlowSelected }) => {
  const [name, setName] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleEdit = () => {
    if (!name.trim()) return notify("warning", "El nombre es requerido", 3000);
    const data = {
      name
    }
    dispatch(editWorkFlow(data, workFlow.id ?? 0, projectId))
  }

  const handleGetStage = (workFlow) => {
    dispatch(setWorkFlowSelected(workFlow))
    dispatch(getStages(workFlow.id));
  }

  const handleReset = () => {
    setShowConfirm(false);
    setIsEdit(false);
    setName("");
  }

  return (
    <div
      key={index}
      className={`flex flex-row h-14 w-full ${workFlowSelected?.id === workFlow.id ? 'bg-gray-500' : "bg-[#EBC533]"}  rounded-xl mb-2 gap-2 cursor-pointer hover:bg-gray-400`}
      onClick={() => {
        if(isEdit) return null;
        handleGetStage(workFlow)
      }}
    >
      <div className='h-full w-1/12 flex items-end'>
        {
          isEdit ? (
            <div
              onClick={()=>setShowConfirm(true)}
              className={`flex justify-center items-center w-4 h-4 rounded-full ${!name.trim() ? 'bg-gray-500' : 'bg-light-blue-800'}  mb-1 ml-1 cursor-pointer text-white hover:bg-white hover:text-light-blue-800`}
            >
              <FaSave className='w-3 h-3' />
            </div>
          ) : (
            <div
              className='flex justify-center items-center w-5 h-5 rounded-full bg-white mb-1 ml-1 cursor-pointer text-yellow-800 hover:bg-yellow-800 hover:text-white'
              onClick={() => {
                setName(workFlow.name)
                setIsEdit(true)
              }}
            >
              <CiEdit className='w-3 h-3' />
            </div>
          )
        }
      </div>
      <div className='flex justify-center items-center h-full w-10/12'>
        {
          isEdit ? (
            <input
              type='text'
              placeholder='Flujo Desc'
              maxLength={50}
              value={name}
              onChange={({ target }) => setName(target.value)}
              className="w-full bg-transparent border-b-2 border-white text-white focus:outline-none focus:ring-0 focus:border-white"
            />
          ) : (
            <p className='text-sm text-white font-bold truncate'>{workFlow.name}</p>
          )
        }
      </div>
      <div className='h-full w-1/12'>
        {
          isEdit && (
            <div
              className='flex justify-center items-center w-4 h-4 rounded-full bg-red-700 mt-1 mr-1 cursor-pointer text-white hover:text-red-700 hover:bg-white'
              onClick={() => {
                setName("")
                setIsEdit(false)
              }}
            >
              <MdClose className='w-3 h-3' />
            </div>
          )
        }
      </div>
      {
        showConfirm && (
          <ModalConfirm
            onClose={() => handleReset()}
            description="¿Estas seguro de editar este flujo de trabajo?"
            onAcept={() => handleEdit()}
            title="Edición de flujo de trabajo"
          />
        )
      }
    </div>
  )
}

const NewCardWorkFlow = ({ dispatch, setShowCard, projectId, workFlowsList }) => {
  const [name, setName] = useState('');

  const handleSave = () => {
    if (!name.trim()) return notify("warning", "El nombre es requerido", 3000)
    const exitsWorkFlow = workFlowsList.some((item) => item.name.trim().toLowerCase() === name.trim().toLowerCase());
    if (exitsWorkFlow) return notify("warning", "El nombre de este flujo ya éxiste", 3000);
    dispatch(saveWorkFlow({ name, projectId }))
  }

  return (
    <div className='flex flex-row h-14 w-full bg-[#EBC533] rounded-xl mb-2'>
      <div className='h-full w-1/12 flex items-end'>
        <div
          onClick={handleSave}
          className={`flex justify-center items-center w-4 h-4 rounded-full ${!name.trim() ? 'bg-gray-500' : 'bg-light-blue-800'}  mb-1 ml-1 cursor-pointer text-white hover:bg-white hover:text-light-blue-800`}
        >
          <FaSave className='w-3 h-3' />
        </div>
      </div>
      <div className='flex justify-center items-center h-full w-10/12'>
        <input
          type='text'
          placeholder='Flujo Desc'
          maxLength={50}
          value={name}
          onChange={({ target }) => setName(target.value)}
          className="w-full bg-transparent border-b-2 border-white text-white focus:outline-none focus:ring-0 focus:border-white"
        />
      </div>
      <div className='h-full w-1/12'>
        <div
          className='flex justify-center items-center w-4 h-4 rounded-full bg-red-700 mt-1 mr-1 cursor-pointer text-white hover:text-red-700 hover:bg-white'
          onClick={() => {
            setName("")
            setShowCard(false)
          }}
        >
          <MdClose className='w-3 h-3' />
        </div>
      </div>
    </div>
  )
}

const ListWorkFlows = () => {
  const { workFlowsList, workFlowSelected } = useSelector((state) => state.workFlow);
  const { currentProject } = useSelector((state) => state.auth);
  const { PUBLIC_URL } = process.env;
  const [showCard, setShowCard] = useState(false);
  const dispatch = useDispatch();

  return (
    <>
      <div className='flex flex-row justify-between items-center'>
        <p className='text-gray-500 font-semibold'>Flujos disponibles</p>
        <img
          className='h-8 w-8 cursor-pointer hover:scale-105 transition-transform'
          src={`${PUBLIC_URL}/icons/btns/btn_add.svg`} alt="#"
          onClick={() => {
            setShowCard(true)
          }}
        />
      </div>
      <div className='w-full mt-3 max-h-full overflow-auto pb-10'>
        {
          showCard && (
            <NewCardWorkFlow
              setShowCard={setShowCard}
              dispatch={dispatch}
              projectId={currentProject.id}
              workFlowsList={workFlowsList}
            />
          )
        }
        {
          workFlowsList.map((item, index) => (
            <CardWorkFlow
              workFlow={item}
              key={index}
              dispatch={dispatch}
              projectId={currentProject.id}
              workFlowSelected={workFlowSelected}
            />
          ))
        }
      </div>
    </>
  )
}

export default ListWorkFlows
